import React, {useState} from 'react'
import {Input, Button, Form, ConfigProvider, Alert} from "antd"
import { LockOutlined } from '@ant-design/icons';
import logo from "../assets/Logo-1.png";
import Lock from '../assets/lock.png';

const ForgetPassword = () => {
    
    const [form] = Form.useForm()
    const passVal = Form.useWatch('password', form);
    const passVal2 = Form.useWatch('confirmpassword', form);
    const [loading, setLoading] = useState(false);
    const [finished, setFinished] = useState(false);
    const [error, setError] = useState(null);

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const userId = urlParams.get("userId");
    if(!token || !userId) window.location.replace("/");

    const resetPassword = async (values) => {
        try {
            setLoading(true);
            setError(null);
            const req = await fetch("https://api.thebooker.online/api/Auth/reset-password-web",
            {
                method: 'POST',
                body: JSON.stringify({userId, token: encodeURIComponent(token), password: values.password}),
                headers: {
                    'Content-type': 'application/json'
                }
            });
            if(req.status == 200 || req.status == 201 || req.status == 204){
                setFinished(true);
                setLoading(false)
            } else {
                const res = await req.json();
                setError(typeof res == 'object' && res.hasOwnProperty("errors") && res.errors.length > 0 ? res.errors[0] : res.message);
                setLoading(false);
            }
        } catch (error) {
            setError("There seems to be an issue, please contact your administrator.");
            setLoading(false);
        }
    }

  return (
    <ConfigProvider theme={{token: {colorPrimary: '#008A80'}}}>
    <div className='login-main' style={{background: '#008A80'}}>
        <div className='login-main-card'>

            <div className='login-div1' >
                <img src={logo} alt='The Booker Logo' style={{objectFit:'contain', width: '70%'}} />
            </div>

            <div className='login-div2'>
                <div style={{width: '80%', display: 'flex', flexDirection:'column', alignItems:'center'}}>
                    <img src={Lock} alt='Reset password Lock ' style={{objectFit:'contain', width: 90}} />
                    <p className='login-msg1'>Reset your password</p>

                    {(finished || error) && <Alert message={error ?? "Reset password successful"} type={error ? "error" : "success"} showIcon style={{marginTop: 10}} />}

                    {!finished &&
                    <Form
                    form={form}
                    onFinish={resetPassword}
                    >
                        <div className='login-inputs-main-div'>

                            
                                <Form.Item className='login-form-item' name='password' rules={[{required: true, message: 'Password is required'}]}>
                                    <Input.Password placeholder='New Password' type='password' addonBefore={<LockOutlined />} />
                                </Form.Item>

                                <Form.Item className='login-form-item' style={{marginTop: 15}} name='confirmpassword' rules={[{required: true, message: 'Password confirmation is required'}]}>
                                    <Input.Password placeholder='Confirm' addonBefore={<LockOutlined />}  />
                                </Form.Item>

                                <div className='button-div button-div2'>
                                    <Button disabled={(!passVal2 && !passVal) || (passVal2 !== passVal)} type='primary' htmlType="submit" size='large' loading={loading} style={{width: '100%'}} >Reset</Button> 
                                </div>
                        </div>
                    </Form> 
                    }

                </div>
            </div>
            
        </div>
    </div>
    </ConfigProvider>
  )
}

export default ForgetPassword